import { render, staticRenderFns } from "./sksq.vue?vue&type=template&id=6165c153&scoped=true&"
import script from "./sksq.vue?vue&type=script&lang=js&"
export * from "./sksq.vue?vue&type=script&lang=js&"
import style0 from "./sksq.vue?vue&type=style&index=0&id=6165c153&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165c153",
  null
  
)

export default component.exports